import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { FaRegCheckCircle, FaRegTrashAlt } from 'react-icons/fa';
import styles from '../Dashboard.module.css';

const Reviews = () => {
  const { reviews } = useOutletContext();

  return (
    <section id="reviews" className={styles.dataSection}>
      <header className={styles.header}>
        <h2>Avis Clients</h2>
      </header>
      <div className={styles.tableContainer}>
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Client</th>
              <th>Note</th>
              <th>Commentaire</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reviews.filter(r => r.status === 'pending').map(review => (
              <tr key={review.id}>
                <td>{review.expand?.user?.name || 'N/A'}</td>
                <td>{'⭐'.repeat(review.rating)}</td>
                <td>{review.comment}</td>
                <td><span className={`${styles.status} ${styles[review.status]}`}>{review.status}</span></td>
                <td className={styles.actions}>
                  {review.status === 'pending' && (
                    <button className={styles.approve} title="Approuver l'avis" aria-label="Approuver">
                      <FaRegCheckCircle size={18} />
                    </button>
                  )}
                  <button className={styles.delete} title="Supprimer l'avis" aria-label="Supprimer">
                    <FaRegTrashAlt size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default Reviews;
